export const createHandlers = (setLoading: (...args: Array<any>) => any, onSuccess: (...args: Array<any>) => any) => {
  return {
    onAPIRequestStart: () => setLoading(true),
    onAPIRequestFinish: () => setLoading(false),
    onSuccess: (response: unknown) => onSuccess(response),
  };
};
